import { HolidayRule } from "../models/HolidayRule";
import { Participant } from "../models/Participant";

export function getParticipantIdForHolidayRule(
  rule: HolidayRule,
  year: number,
): Participant["_id"] | undefined {
  const override = rule.holidayOverrides?.find(
    (override) => override.year === year,
  );
  if (override && override.participant) return override.participant;

  const isOddYear = year % 2 !== 0;

  if (rule.assignmentMode === "every") {
    return rule.everyYearParticipant;
  }

  if (rule.assignmentMode === "alternate") {
    return isOddYear ? rule.oddYearsParticipant : rule.evenYearsParticipant;
  }

  return undefined;
}
